import React, { useState, useEffect } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../contexts/firebase";
import { useNavigate, Link } from "react-router-dom";

export default function ForgetPassword() {
    const [email, setEmail] = useState("");
    const [sending, setSending] = useState(false);
    const [success, setSuccess] = useState("");
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const [error, setError] = useState("");
    const navigate = useNavigate();


    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (user) {
                // User is already logged in, redirect them
                navigate("/dashboard"); // or "/generate" or any other page you want
            }
        });

        return () => unsubscribe();
    }, [navigate]);

    const backgroundImage = isMobile
        ? "https://geneartai.com/images/mobile1.png"
        : "https://geneartai.com/images/image1.png";

    const handleReset = async (e) => {
        setError("");  // Clear previous error message
        setSuccess("");  // Reset success state
        e.preventDefault();
        if (!emailRegex.test(email.trim())) {
            setError("Please enter a valid email address.");
            setTimeout(() => {
                setError("");
            }, 7000);
            return;
        }

        try {
            setSending(true);
            await sendPasswordResetEmail(auth, email.trim(), {
                url: "https://geneartai.com/reset-password",
            });
            setSuccess("If an account with this email exists, you will receive a password reset email shortly.");
            // Automatically clear success message after 7 seconds
            setTimeout(() => {
                setSuccess("");
            }, 7000);
            setEmail("");
        } catch (err) {
            console.error(err);

            if (err.code === "auth/user-not-found") {
                setError("No account found with this email address.");
            } else if (err.code === "auth/invalid-email") {
                setError("Please enter a valid email address.");
            } else {
                setError("Something went wrong. Please try again later.");
            }
        } finally {
            setSending(false);
        }
    };


    return (
        <div className="relative min-h-screen font-sans text-white overflow-x-hidden">
            {/* Responsive Background */}
            <div
                className="fixed inset-0 bg-cover bg-center z-0"
                style={{
                    backgroundImage: `url('${backgroundImage}')`,
                    backgroundAttachment: isMobile ? "scroll" : "fixed",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="absolute inset-0"></div>
            </div>
            <div className="relative z-10 flex flex-col min-h-screen">
                <div className="flex-grow flex items-center justify-center px-4 py-8 pt-20">
                    <form onSubmit={handleReset} className="bg-black/30 backdrop-blur-md p-8 rounded-2xl shadow-2xl w-full max-w-md">
                        <h2 className="text-2xl font-bold text-center mb-6 text-white">Forget Password ?</h2>
                        <input
                            type="text"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                            className="w-full mb-4 px-4 py-2 rounded-lg bg-black/20 border border-gray-600 text-white"
                        />
                        {success && (
                            <div className="bg-green-500 text-white text-base p-2 rounded-lg mb-4 border border-green-400 text-center">
                                {success}
                            </div>
                        )}
                        {error && (
                            <div className="bg-red-500 text-white text-sm text-center rounded-md p-2 mb-4">
                                {error}
                            </div>
                        )}

                        <button
                            type="submit"
                            disabled={sending}
                            className="w-full py-1.5 rounded-full font-semibold bg-[#166CB0] hover:bg-blue-800 text-white shadow-md hover:shadow-lg"
                        >
                            {sending ? "Sending..." : "Send Reset Link"}
                        </button>
                    </form>
                </div>
                {/* Footer */}
                <footer className="text-center text-xs text-gray-300 pb-3">
                    <div>© 2025 GeneArtAI — All Rights Reserved.</div>
                    <div className="mt-2">
                        <Link to="/privacy-policy" className="text-gray-300 hover:text-white underline">
                            Privacy Policy
                        </Link>{" "}
                        |{" "}
                        <Link to="/terms-of-service" className="underline hover:text-white">
                            Terms of Service
                        </Link>
                    </div>
                </footer>

                {/* Mobile Bottom Ad Spacer */}
                <div className="block sm:hidden h-20" />
            </div>


        </div>
    );
}
